import { Box, Typography } from "@mui/material"

export function PdfComparisonTable({ originalVersion, draftVersion, children }) {
    return (
        <Box
            component="table"
            sx={{
                width: "100%",
                tableLayout: "fixed",
                borderCollapse: "collapse",
                borderSpacing: 0,
                "@media print": {
                    "& thead": { display: "table-header-group" },
                },
            }}
        >
            <Box component="colgroup">
                <Box component="col" sx={{ width: "50%" }} />
                <Box component="col" sx={{ width: "50%" }} />
            </Box>
            <Box component="thead" sx={{ display: "table-header-group" }}>
                <Box component="tr">
                    <Box component="th" sx={getHeaderCellSx("left")}>
                        <Box sx={getHeaderBoxSx("left")}>
                            <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "#374151" }}>
                                Previous
                            </Typography>
                            <Typography sx={{ fontSize: "9px", color: "#6b7280", mt: "2px" }}>
                                Version {originalVersion || "—"}
                            </Typography>
                        </Box>
                    </Box>
                    <Box component="th" sx={getHeaderCellSx("right")}>
                        <Box sx={getHeaderBoxSx("right")}>
                            <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "white" }}>
                                Amendments
                            </Typography>
                            <Typography sx={{ fontSize: "9px", color: "rgba(255,255,255,0.82)", mt: "2px" }}>
                                Version {draftVersion || "—"}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box component="tr" sx={{ height: "18px" }}>
                    <Box component="th" sx={getSpacerCellSx("left")} />
                    <Box component="th" sx={getSpacerCellSx("right")} />
                </Box>
            </Box>
            {children}
        </Box>
    )
}

function getHeaderCellSx(side) {
    return {
        padding: 0,
        pt: "8px",
        pb: "18px",
        textAlign: "left",
        verticalAlign: "top",
        fontWeight: 400,
        width: "50%",
        ...(side === "left" ? { pr: "5px" } : { pl: "5px" }),
    }
}

function getSpacerCellSx(side) {
    return {
        padding: 0,
        ...(side === "left" ? { pr: "5px" } : { pl: "5px" }),
    }
}

function getHeaderBoxSx(side) {
    return {
        borderRadius: "8px",
        px: "20px",
        py: "12px",
        bgcolor: side === "left" ? "#ebecef" : "#3f9ba5",
    }
}
